import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BlogPostDetail from '../components/blog/BlogPostDetail';
import { useBlog } from '../hooks/useBlog';

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { getBySlug } = useBlog();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError(null);

    getBySlug(slug)
      .then((p) => {
        if (!mounted) return;
        if (!p) setError('Article not found');
        else setPost(p);
      })
      .catch((err) => {
        console.error(err);
        if (mounted) setError('Failed to load article');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => { mounted = false; };
  }, [slug, getBySlug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 pt-24 px-4 py-12">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-lg text-gray-600">Loading article...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 pt-24 px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow p-8 text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">{error}</h1>
            <button
              onClick={() => navigate('/blog')}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 font-semibold transition"
            >
              ← Back to Blog
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <button
          onClick={() => navigate('/blog')}
          className="text-blue-600 hover:text-blue-800 font-semibold mb-8 inline-flex items-center gap-2"
        >
          ← Back to Blog
        </button>

        <div className="bg-white rounded-lg shadow-lg p-8 sm:p-12">
          <BlogPostDetail post={post} />
        </div>

        <div className="mt-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">More Articles</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition cursor-pointer" onClick={() => navigate('/blog/understanding-family-law')}>
              <span className="inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                Family Law
              </span>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Understanding Family Law: Your Rights and Responsibilities</h4>
              <p className="text-gray-600 text-sm">A comprehensive guide to family law covering marriage, divorce, custody, and more.</p>
            </div>
            <div className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition cursor-pointer" onClick={() => navigate('/blog/criminal-defense-basics')}>
              <span className="inline-block bg-red-100 text-red-800 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                Criminal Law
              </span>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Criminal Defense Basics: What You Need to Know</h4>
              <p className="text-gray-600 text-sm">Learn the fundamentals of criminal defense and your rights when facing charges.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPost;
